import React, { useContext } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import { roleContext, LanguageContext } from "../../../libs/context";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Amplify, { Auth, API } from "aws-amplify";
import { toast } from "react-toastify";
import deviceInfo from "../../../containers/confsimulcast/conference/msoup/deviceInfo";
import "./styles.css";
import { removeUserAccount } from "../../../containers/actions/profile";

function ProfileMenu(props) {
  const { isOpen, onClose } = props;

  const role = useContext(roleContext);
  const language = useContext(LanguageContext);
  const location = useLocation();
  const history = useHistory();

  const handleItemClick = () => {
    onClose();
  };

  const setAwsconfig = async (subDomainData) => {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: JSON.parse(import.meta.env.VITE_cognito).REGION,
        userPoolId: subDomainData.poolId,
        identityPoolId: subDomainData.identityPoolId,
        userPoolWebClientId: subDomainData.appClientId,
      },
      Storage: {
        region: JSON.parse(import.meta.env.VITE_s3).REGION,
        bucket: JSON.parse(import.meta.env.VITE_s3).PROFILEBUCKET,
        identityPoolId: subDomainData.identityPoolId,
      },
      API: {
        endpoints: [
          {
            name: "insta",
            endpoint: JSON.parse(import.meta.env.VITE_apiGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiGateway).REGION,
          },
          {
            name: "domain",
            endpoint: JSON.parse(import.meta.env.VITE_apiDomainGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiDomainGateway).REGION,
          },
          {
            name: "mcu",
            endpoint: JSON.parse(import.meta.env.VITE_apiMcuGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMcuGateway).REGION,
          },
          {
            name: "user",
            endpoint: JSON.parse(import.meta.env.VITE_apiUserGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiUserGateway).REGION,
          },
          {
            name: "plan",
            endpoint: JSON.parse(import.meta.env.VITE_apiPlanGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiPlanGateway).REGION,
          },
          {
            name: "coupon",
            endpoint: JSON.parse(import.meta.env.VITE_apiCouponGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiCouponGateway).REGION,
          },
          {
            name: "transaction",
            endpoint: JSON.parse(import.meta.env.VITE_apiTransactionGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiTransactionGateway).REGION,
          },
          {
            name: "referral",
            endpoint: JSON.parse(import.meta.env.VITE_apiReferralGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiReferralGateway).REGION,
          },
          {
            name: "recording",
            endpoint: JSON.parse(import.meta.env.VITE_apiRecordingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiRecordingGateway).REGION,
          },
          {
            name: "mcu_recording",
            endpoint: JSON.parse(import.meta.env.VITE_apimcuRecordingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apimcuRecordingGateway).REGION,
          },
          {
            name: "content",
            endpoint: JSON.parse(import.meta.env.VITE_apiContentGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiContentGateway).REGION,
          },
          {
            name: "schedule",
            endpoint: JSON.parse(import.meta.env.VITE_apiScheduleGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiScheduleGateway).REGION,
          },
          {
            name: "address",
            endpoint: JSON.parse(import.meta.env.VITE_apiAddressGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiAddressGateway).REGION,
          },
          {
            name: "multipart_upload",
            endpoint: JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway).REGION,
          },
          {
            name: "meetings",
            endpoint: JSON.parse(import.meta.env.VITE_apiMeetingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMeetingGateway).REGION,
          },
          {
            name: "mail",
            endpoint: JSON.parse(import.meta.env.VITE_apiMailGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMailGateway).REGION,
          },
          {
            name: "broadcast",
            endpoint: JSON.parse(import.meta.env.VITE_apiBroadcastGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiBroadcastGateway).REGION,
          },
          {
            name: "test",
            endpoint: JSON.parse(import.meta.env.VITE_apiTestGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiTestGateway).REGION,
          },
          {
            name: "doc_share",
            endpoint: JSON.parse(import.meta.env.VITE_apiDocumentShareGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiDocumentShareGateway).REGION,
          },
          {
            name: "chat",
            endpoint: JSON.parse(import.meta.env.VITE_apiChatGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiChatGateway).REGION,
          },
          {
            name: "admin",
            endpoint: JSON.parse(import.meta.env.VITE_apiAdminGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiAdminGateway).REGION,
          },
          {
            name: "inVCSchedule",
            endpoint: JSON.parse(import.meta.env.VITE_invcScheduleAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcScheduleAPI).REGION,
          },
          {
            name: "inVCEmail",
            endpoint: JSON.parse(import.meta.env.VITE_invcEmailAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcEmailAPI).REGION,
          },
          {
            name: "inVCLicense",
            endpoint: JSON.parse(import.meta.env.VITE_invcLicenseAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcLicenseAPI).REGION,
          },
          {
            name: "class",
            endpoint: JSON.parse(import.meta.env.VITE_apiClassCreateGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiClassCreateGateway).REGION,
          },
          {
            name: "inclassChat",
            endpoint: JSON.parse(import.meta.env.VITE_inclassChatAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassChatAPI).REGION,
          },
          {
            name: "inClassMcu",
            endpoint: JSON.parse(import.meta.env.VITE_inclassMcuAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassMcuAPI).REGION,
          },
          {
            name: "inClassReports",
            endpoint: JSON.parse(import.meta.env.VITE_inclassReportsAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassReportsAPI).REGION,
          },
          {
            name: "inClassAssessments",
            endpoint: JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI).REGION,
          },
          {
            name: "inaffiliateUser",
            endpoint: JSON.parse(import.meta.env.VITE_inaffiliateUserAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inaffiliateUserAPI).REGION,
          },
        ],
      },
    });
  };

  const handleLogout = async () => {
    onClose();
    try {
      await Auth.signOut();
      const device = deviceInfo();
      if (device.platform === 'mobile') {
        localStorage.removeItem('subDomain');
        setAwsconfig({
          poolId: JSON.parse(import.meta.env.VITE_cognito).USER_POOL_ID,
          identityPoolId: JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
          appClientId: JSON.parse(import.meta.env.VITE_cognito).APP_CLIENT_ID
        });
      }
      localStorage.removeItem('role');
      localStorage.removeItem('userId');
      history.push("/");
      window.location.reload();
    } catch (error) {
      console.log("Error signing out: ", error);
    }
  };

  const handleRemoveAccount = async () => {
    onClose();
    try {
      const res = await removeUserAccount();
      if (res.status) {
        toast.success(language.account_del_succ || "Account deleted successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        await Auth.signOut();
        localStorage.removeItem('role');
        localStorage.removeItem('userId');
        history.push("/");
        window.location.reload();
      } else {
        toast.error(res?.response?.data?.error || "Failed to delete account", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (err) {
      console.log("Error removing account: ", err);
      toast.error("An error occurred while deleting account", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      {/* Dark overlay behind menu */}
      {/* When clicked, closes the menu */}
      <div className="profile-menu-overlay" onClick={onClose} />

      {/* The actual menu that slides up */}
      <div className="profile-menu">
        {/* Header with title and close button */}
        <div className="profile-menu-header">
          <h3>{language.myProfile || "My Profile"}</h3>
          <IconButton onClick={onClose} size="small" aria-label="close">
            <CloseIcon />
          </IconButton>
        </div>

        {/* Menu items list */}
        <div className="profile-menu-items">
          {/* ========== ITEM 1: MY PROFILE PAGE ========== */}
          <NavLink
            to="/myprofile"
            className={({ isActive }) =>
              isActive ? "profile-menu-item active" : "profile-menu-item"
            }
            onClick={handleItemClick}
          >
            <img
              src="/images/blue/profile.png"
              alt="Profile"
              className="menu-item-icon"
            />
            <span>{language.myProfile || "My Profile"}</span>
          </NavLink>

          {/* ========== ITEM 2: SETTINGS ========== */}
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              isActive ? "profile-menu-item active" : "profile-menu-item"
            }
            onClick={handleItemClick}
          >
            <img
              src="/images/blue/settings-24.png"
              alt="Settings"
              className="menu-item-icon"
            />
            <span>{language.settings || "Settings"}</span>
          </NavLink>

          {/* ========== ITEM 3: LICENSES (Admin Only) ========== */}
          {role === "Admin" && (
            <NavLink
              to="/licenses"
              className={({ isActive }) =>
                isActive ? "profile-menu-item active" : "profile-menu-item"
              }
              onClick={handleItemClick}
            >
              <img
                src="/images/blue/license.png"
                alt="Licenses"
                className="menu-item-icon"
              />
              <span>{language.instavc_admin_licenses || "Licenses"}</span>
            </NavLink>
          )}

          {/* ========== ITEM 4: HELP CENTER ========== */}
          {/* Opens external link in new tab */}
          <a
            href="https://help.instavc.com/inclass"
            target="_blank"
            rel="noopener noreferrer"
            className="profile-menu-item"
            onClick={handleItemClick}
          >
            <img
              src="/images/play-button.png"
              alt="Help Center"
              className="menu-item-icon"
            />
            <span>{language.help_Center || "Help Center"}</span>
          </a>

          {/* Divider line */}
          <div className="profile-menu-divider" />

          {/* ========== ITEM 5: REMOVE ACCOUNT ========== */}
          <div
            className="profile-menu-item danger"
            onClick={handleRemoveAccount}
          >
            <img
              src="/images/blue/delete.png"
              alt="Remove Account"
              className="menu-item-icon"
            />
            <span>{language.removeAccount || "Remove Account"}</span>
          </div>

          {/* ========== ITEM 6: LOGOUT ========== */}
          <div className="profile-menu-item" onClick={handleLogout}>
            <img
              src="/images/blue/logout.png"
              alt="Logout"
              className="menu-item-icon"
            />
            <span>{language.logout || "Logout"}</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileMenu;
